module.exports = __webpack_public_path__ + "files/66c4531be9721173147e259db2af055f.png";